class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    
    // Ajouter la gestion du hover pour le mega menu
    this.setupHoverBehavior();
  }

  setupHoverBehavior() {
    const summary = this.mainDetailsToggle.querySelector('summary');
    const content = this.mainDetailsToggle.querySelector('.mega-menu__content');
    
    if (!summary || !content) return;

    let hoverTimeout;

    // Ouvrir au hover sur le summary
    summary.addEventListener('mouseenter', () => {
      clearTimeout(hoverTimeout);
      // Fermer tous les autres mega menus avant d'ouvrir celui-ci
      this.closeOtherMegaMenus();
      this.open();
    });

    // Fermer quand on quitte le summary
    summary.addEventListener('mouseleave', () => {
      hoverTimeout = setTimeout(() => {
        if (!this.mainDetailsToggle.matches(':hover')) {
          this.close();
        }
      }, 100);
    });

    // Garder ouvert quand on hover sur le contenu
    content.addEventListener('mouseenter', () => {
      clearTimeout(hoverTimeout);
    });

    // Fermer quand on quitte le contenu
    content.addEventListener('mouseleave', () => {
      hoverTimeout = setTimeout(() => {
        if (!this.mainDetailsToggle.matches(':hover')) {
          this.close();
        }
      }, 100);
    });

    // Désactiver le clic sur le summary
    summary.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
    });
  }

  closeOtherMegaMenus() {
    // Fermer tous les autres mega menus pour éviter les conflits visuels
    const allMegaMenus = document.querySelectorAll('header-menu details[open]');
    allMegaMenus.forEach(menu => {
      if (menu !== this.mainDetailsToggle) {
        menu.removeAttribute('open');
        const summary = menu.querySelector('summary');
        if (summary) {
          summary.setAttribute('aria-expanded', false);
        }
      }
    });
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
